// src/layouts/AdminLayout.js
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../components/AdminSidebar';
import Footer from '../components/Footer';
import './CommonLayout.css';

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1024;
      setIsMobile(mobile);
      if (mobile) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="common-layout">
      <AdminSidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />
      <div className={`common-main ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="common-content">
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
}